import React from "react";
import CartProvider from "../../../providers/CartProvider";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import { AppProps } from "../../BaseApp";
import OrderProvider from "../../../providers/OrderProvider";
import CustomToastContainer from "../../../../shared/ui/custom-toast-container";
import { QueryClientProvider } from "@tanstack/react-query";
import StatusPage, { StatusPageType } from "../../../../pages/status";
import { queryClient } from "app/apps/queryClient";

const App: React.FC<AppProps> = (props, context) => {
  const getBasename = (): string => {
    return props.configuration.basename || "afspraak-status";
  };
  return (
    <div className="gg">
      <BrowserRouter>
        <QueryClientProvider client={queryClient}>
          <CartProvider>
            <OrderProvider>
              <CustomToastContainer />
              <Routes>
                <Route
                  path={getBasename()}
                  element={<StatusPage type={StatusPageType.APPOINTMENT} />}
                />
              </Routes>
            </OrderProvider>
          </CartProvider>
        </QueryClientProvider>
      </BrowserRouter>
    </div>
  );
};

export default App;
